import { render } from "./MultiSelectComponent.vue?vue&type=template&id=b3fa9e4a&scoped=true"
import script from "./MultiSelectComponent.vue?vue&type=script&lang=js"
export * from "./MultiSelectComponent.vue?vue&type=script&lang=js"

import "./MultiSelectComponent.vue?vue&type=style&index=0&id=b3fa9e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fa9e4a"]])

export default __exports__